import { Helmet } from 'react-helmet-async';
import { SEO_DEFAULTS } from '@/lib/content';

export default function SEO({ title, description, path = '/', image, type = 'website', schema }) {
  const fullTitle = title
    ? `${title} · ${SEO_DEFAULTS.siteName}`
    : `${SEO_DEFAULTS.siteName} · Award-Winning Digital Marketing Agency in Florida`;
  const url = `${SEO_DEFAULTS.domain}${path}`;
  const img = image || SEO_DEFAULTS.defaultImage;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
